export function isDefinedArray<T>(arr: (T | undefined)[]): arr is T[] {
  return arr.every((item) => item !== undefined);
}
